// extracted by mini-css-extract-plugin
export const root = "figure-module--root--1FgYF";
export const button = "figure-module--button--5M9yo";